module.exports = __webpack_public_path__ + "static/media/share.2d8de576.svg";